import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  Fragment,
} from "react";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";
// import Input from '@mui/material/Input';
import InputAdornment from "@mui/material/InputAdornment";
import Container from "@mui/material/Container";
import "./ProjectInformation.css";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import ArcGISMap from "@arcgis/core/Map";
// import IdentityManager from "@arcgis/core/identity/IdentityManager";
import ShowAddServiceArea from "./ShowAddServiceArea";
import ShowUnitsConfiguration from "./ShowUnitsConfiguration";
import ShowRolesConfiguration from "./ShowRolesConfiguration";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ProjectContext from "../../context/project/ProjectContext";
import { processProjectData } from "../../utils/ProjectAPI";
import { ServiceIndex } from "../../config/APIRoutes";
// import userList from "../../data/user.json";
import officeList from "../../data/leadoffices.json";
import projectTypeList from "../../data/projecttype.json";
import { useNavigate } from "react-router-dom";

function ProjectInformation() {
  const projectContext = useContext(ProjectContext);
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const {
    generateNewProjectID,
    intelliFiberUserRoles,
    selectProject,
    selectedProject,
    getProjectsV2,
    users,
    getProjectbyObjectId,
    clientUserList,
    getClients,
  } = projectContext;
  const { showAlert, showSnackbar } = alertContext;
  const navigate = useNavigate();
  const handleClick = () => navigate("/");

  const [buttonFalg, setFlag] = React.useState(false);
  const [formIsValid, setFormIsValid] = useState(false);
  const [openServiceArea, setOpenServiceArea] = React.useState(false);
  const [openUnitsConfig, setOpenUnitsConfig] = React.useState(false);
  const [openRolesConfig, setOpenRolesConfig] = React.useState(false);
  const [clientList, setClientList] = React.useState([]);
  const [createdFlag, setCreatedFlag] = React.useState(false);

  const initForm = {
    NetSuiteID: "",
    ID: "",
    Name: "",
    ProjectManager: "",
    LeadOffice: "",
    ClientName: "",
    ClientContactPhone: "",
    ClientContactEmail: "",
    ProjectType: "",
    EstimatedNoOfMiles: "0",
    EstNoOfPremises: "0",
    PercentCompleted: "0",
    ClientPrimaryContact: "",
    Description: "",
    Status: "New",
  };

  const errorForm = {
    Name: false,
  };

  const [projectObj, setProjectObj] = React.useState(initForm);
  const [errorObj, setErrorObj] = React.useState(errorForm);
  // const [users] = React.useState(userList);
  const handleClickOpenServiceArea = () => {
    console.log("##Project:", projectObj?.ID);
    console.log("##Project:", selectedProject?.ID);

    if (projectObj?.ID) setOpenServiceArea(true);
    else {
      showAlert(
        "Please create the project prior to configuring Service Areas",
        "Info"
      );
    }
  };

  const requiredFields = [
    "Name",
    "ProjectManager",
    "LeadOffice",
    "ProjectType",
    "EstimatedNoOfMiles",
    "ClientName",
  ];

  const getUserRoleType = () => {
    //check User's Role
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      console.log("$$$USER :", user);
      const role = intelliFiberUserRoles.find(
        (item) => item.UserID === user?.userID
      );
      console.log("$$$USER Role:", role);
      if (role) {
        return role.RoleName ? role.RoleName : "";
      }
    }
    return "";
  };

  const checkValidation = () => {
    let hasErrors = false;
    const errorObjCopy = { ...errorObj };

    for (const key in projectObj) {
      if (projectObj[key] === "") {
        hasErrors = true;
        errorObjCopy[key] = true;
      } else {
        errorObjCopy[key] = false;
      }
    }

    setErrorObj(errorObjCopy);
    setFormIsValid(!hasErrors);

    console.log("Erorr Obj", errorObj);
    const isValid = requiredFields.every((key) => !errorObjCopy[key]);
    return isValid;
  };

  const handleServiceAreaClose = () => {
    setOpenServiceArea(false);
  };

  const handleClickUnitsConfig = () => {
    console.log("##Project:", projectObj?.ID);
    if (projectObj?.ID) setOpenUnitsConfig(true);
    else {
      showAlert("Please create the project prior to configuring Units", "Info");
    }
  };

  const handleUnitsConfigClose = () => {
    setOpenUnitsConfig(false);
  };

  const handleClickRolesConfig = () => {
    if (projectObj?.ID) setOpenRolesConfig(true);
    else {
      showAlert(
        "Please create the project prior to configuring Project Roles",
        "Info"
      );
    }
  };

  const handleRolesConfigClose = () => {
    setOpenRolesConfig(false);
  };

  const fetchOptionDetails = async () => {
    if (clientUserList && clientUserList.length > 0) {
      setClientList(clientUserList);
    } else {
      const res = await getClients();
      setClientList(res);
    }
  };

  useEffect(() => {
    // if (projectObj) projectObj.ID = "1003";
    // selectProject(projectObj);
    fetchOptionDetails();
    if (getUserRoleType() !== "Central GIS Team") {
      handleClick();
    }
    return () => {
      selectProject(null);
      console.log("CLEARNING PROJECT");
    };
  }, []);

  useEffect(() => {
    // if (projectObj) projectObj.ID = "1003";
    if (selectedProject) {
      //setProjectObj(selectedProject)
      console.log("GLob PROJECT", selectedProject);
      console.log("Local PROJECT", projectObj);
    }
  }, [selectedProject]);

  useEffect(() => {
    const isFormValid = requiredFields.every((field) => projectObj[field]);
    setFormIsValid(isFormValid);
  }, [projectObj]);

  const formSubmissionHandler = async () => {
    const isValid = checkValidation();

    if (isValid) {
      // const newID = generateNewProjectID();
      // console.log("NEW PROJECT ID", newID);
      // projectObj.ID = newID;
      console.log("NEW PROJECT", projectObj);
      const result = await processProjectData(
        ServiceIndex.Projects,
        projectObj,
        "ADD"
      );

      console.log("Add Result ", result);
      if (result && result.length > 0) {
        let _projObj = {};
        _projObj.OBJECTID = result[0].objectId;

        console.log("NEW PROJECT Object", result);
        // projectObj.OBJECTID = result[0].objectId;
        // projectObj.ID = result[0].objectId;
        // selectProject(projectObj);
        try {
          _projObj = await getProjectbyObjectId(_projObj.OBJECTID);
          if (_projObj[0]) {
            setProjectObj(() => _projObj[0]);
            console.log("NEW PROJECT selected", _projObj[0]);
            setCreatedFlag(true);
            showSnackbar(
              `Project ${projectObj.Name}(${projectObj.ID}) has been created Successfully`,
              "success"
            );
          }
        } catch (error) {
          console.log("NEW PROJECT Create Error", error);
        }

        getProjectsV2();
      }
    }
  };

  const showServiceArea = () => {
    return openServiceArea ? (
      <ShowAddServiceArea
        showDialog={openServiceArea}
        handleClose={handleServiceAreaClose}
      />
    ) : (
      <Fragment></Fragment>
    );
  };

  const inputHandler = (e) => {
    const { value, maxLength } = e.target;
    if (String(value).length >= maxLength) {
      e.preventDefault();
      return;
    }
  };

  const onBlurHandle = (field) => {
    setErrorObj({
      ...errorObj,
      [field]: projectObj[field].trim() === "",
    });
  };

  const onFoucsHandle = (field) => {
    setErrorObj({
      ...errorObj,
      [field]: false,
    });
  };

  return (
    <Container>
      {showServiceArea()}
      {openUnitsConfig && (
        <ShowUnitsConfiguration
          showDialog={openUnitsConfig}
          handleClose={handleUnitsConfigClose}
        />
      )}
      {openRolesConfig && (
        <ShowRolesConfiguration
          showDialog={openRolesConfig}
          handleClose={handleRolesConfigClose}
        />
      )}
      <div className="d-flex justify-content-center heading">
        <div className="heading-center">CREATE NEW PROJECT</div>
        <div className="show-btn">
          <Button
            style={{ visibility: buttonFalg === true ? "visible" : "hidden" }}
            variant="light"
            className="custom-btn"
          >
            Paste Project
          </Button>
          <span className="rotate-icon" onClick={() => setFlag(!buttonFalg)}>
            ...
          </span>
        </div>
      </div>
      <div className="underline-bg"></div>
      <h6 className="projectDetails marginBottom">ADD PROJECT DETAILS</h6>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <TextField
              // required
              id="NetSuiteID"
              label="NetSuite ID"
              type="text"
              value={projectObj.NetSuiteID}
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  NetSuiteID: event.target.value,
                })
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <TextField
              required
              id="ProjectName"
              label="Project Name"
              type="text"
              value={projectObj.Name}
              // placeholder='Enter Project Name'
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  Name: event.target.value,
                })
              }
              error={errorObj.Name}
              onFocus={() => onFoucsHandle("Name")}
              onBlur={() => onBlurHandle("Name")}
            />
            {errorObj.Name && (
              <FormHelperText error={true}>
                Please enter a project name{" "}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <InputLabel id="ProjectManagerLabel">
              Project Manager <span>*</span>
            </InputLabel>
            <Select
              required
              labelId="ProjectManagerLabel"
              label="Project Manager"
              value={projectObj.ProjectManager}
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  ProjectManager: event.target.value,
                })
              }
              error={errorObj.ProjectManager}
              onFocus={() => onFoucsHandle("ProjectManager")}
              onBlur={() => onBlurHandle("ProjectManager")}
            >
              <MenuItem value="">
                <em>Select Project Manager</em>
              </MenuItem>
              {users &&
                users.map((user, index) => (
                  <MenuItem key={index} value={user.UserID}>
                    {user.UserID}
                  </MenuItem>
                ))}
            </Select>
            {errorObj.ProjectManager && (
              <FormHelperText error={true}>
                Please select a project manager{" "}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <InputLabel id="LeadOfficeLabel">
              Lead Office <span>*</span>
            </InputLabel>
            <Select
              required
              labelId="LeadOfficeLabel"
              value={projectObj.LeadOffice}
              label="Lead Office"
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  LeadOffice: event.target.value,
                })
              }
              error={errorObj.LeadOffice}
              onFocus={() => onFoucsHandle("LeadOffice")}
              onBlur={() => onBlurHandle("LeadOffice")}
            >
              <MenuItem value="">
                <em>Select Lead Office</em>
              </MenuItem>
              {officeList &&
                officeList.map((office, index) => (
                  <MenuItem key={index} value={office.Name}>
                    {office.Name}
                  </MenuItem>
                ))}
            </Select>
            {errorObj.LeadOffice && (
              <FormHelperText error={true}>
                Please select a lead office{" "}
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <InputLabel id="ClientNameLabel">
              Client Name <span>*</span>
            </InputLabel>
            <Select
              required
              labelId="ClientName"
              value={projectObj.ClientName}
              label="Client Name"
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  ClientName: event.target.value,
                })
              }
              error={errorObj.ClientName}
              onFocus={() => onFoucsHandle("ClientName")}
              onBlur={() => onBlurHandle("ClientName")}
            >
              <MenuItem value="">
                <em>Select Client Name</em>
              </MenuItem>
              {clientList &&
                clientList.map((client, index) => (
                  <MenuItem key={index} value={client.ClientName}>
                    {client.ClientName}
                  </MenuItem>
                ))}
            </Select>
            {errorObj.LeadOffice && (
              <FormHelperText error={true}>
                Please enter a client name
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl
            sx={{ marginTop: 3.5, marginBottom: 3.5, width: "102%" }}
          >
            <InputAdornment position="start">
              <Select value="+01" className="input-bgColor">
                <MenuItem value="+01">+01</MenuItem>
              </Select>
              <TextField
                id="phone-number"
                type={"number"}
                inputProps={{
                  pattern: "[0-9]*",
                  maxlength: "10",
                  inputMode: "tel",
                }}
                className="input-bgColor"
                placeholder="Enter Phone Number"
                onKeyPress={inputHandler}
                sx={{ width: "100%" }}
                value={projectObj.ClientContactPhone}
                onChange={(event) =>
                  setProjectObj({
                    ...projectObj,
                    ClientContactPhone: event.target.value,
                  })
                }
              />
            </InputAdornment>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <TextField
              id="client-email"
              type={"email"}
              label="Client Contact Email"
              // className='input-bgColor'
              placeholder="Enter Email Id"
              value={projectObj.ClientContactEmail}
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  ClientContactEmail: event.target.value,
                })
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <TextField
              id="client-primary-contact"
              // className='input-bgColor'
              label="Client Primary Contact"
              placeholder="Enter Contact"
              value={projectObj.ClientPrimaryContact}
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  ClientPrimaryContact: event.target.value,
                })
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <InputLabel htmlFor="project-type" className="inputLabel">
              Project Type <span>*</span>
            </InputLabel>
            <Select
              required
              id="project-type"
              // className='input-bgColor'
              value={projectObj.ProjectType}
              label="Project Type"
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  ProjectType: event.target.value,
                })
              }
              error={errorObj.ProjectType}
              onFocus={() => onFoucsHandle("ProjectType")}
              onBlur={() => onBlurHandle("ProjectType")}
            >
              <MenuItem value="">
                <em>Select Project Type</em>
              </MenuItem>
              {projectTypeList &&
                projectTypeList.map((type, index) => (
                  <MenuItem key={index} value={type.Name}>
                    {type.Name}
                  </MenuItem>
                ))}
            </Select>
            {errorObj.ProjectType && (
              <FormHelperText error={true}>
                Please select a project type
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <TextField
              required
              id="est-no-of-miles"
              // className='input-bgColor'
              label="Estimated Route Miles"
              inputProps={{
                pattern: "[0-9]*",
                maxlength: "13",
                inputMode: "numeric",
              }}
              onKeyPress={inputHandler}
              type={"number"}
              placeholder="Enter Route Miles"
              value={projectObj.EstimatedNoOfMiles}
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  EstimatedNoOfMiles: event.target.value,
                })
              }
              onFocus={() => onFoucsHandle("EstimatedNoOfMiles")}
              onBlur={() => onBlurHandle("EstimatedNoOfMiles")}
            />
            {errorObj.EstimatedNoOfMiles && (
              <FormHelperText error={true}>
                Please enter estimated no of miles
              </FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <TextField
              id="est-no-of-premises"
              // className='input-bgColor'
              label="Est of Premises"
              inputProps={{
                pattern: "[0-9]*",
                maxlength: "13",
                inputMode: "numeric",
              }}
              onKeyPress={inputHandler}
              type={"number"}
              placeholder="Enter Est of Premises"
              value={projectObj.EstNoOfPremises}
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  EstNoOfPremises: event.target.value,
                })
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControl fullWidth>
            <TextField
              // className='input-bgColor textarea-height'
              label="Project Description"
              multiline
              rows={3}
              // minHeight="20px"
              // placeholder='Enter Project Description...'
              value={projectObj.Description}
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  Description: event.target.value,
                })
              }
            />
          </FormControl>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <TextField
              // className='input-bgColor textarea-height'
              label='Scope *'
              multiline
              rows={3}
              minHeight='20px'
              value={projectObj.Scope}
              onChange={(event) =>
                setProjectObj({
                  ...projectObj,
                  Scope: event.target.value,
                })
              }
              error={errorObj.Scope}
              onFocus={() => onFoucsHandle("Scope")}
              onBlur={() => onBlurHandle("Scope")}
            />
            {errorObj.Scope && (
              <FormHelperText error={true}>Please enter scope</FormHelperText>
            )}
          </FormControl>
        </Grid> */}

        <Grid
          display="flex"
          flexDirection="row"
          container
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            color="secondary"
            className="submit-btn"
            sx={{ margin: 2 }}
            onClick={formSubmissionHandler}
            disabled={!formIsValid || createdFlag}
          >
            ADD PROJECT
          </Button>
        </Grid>
      </Grid>
      <Grid sx={{ marginTop: 2 }}>
        <Typography gutterBottom variant="h6" component="div">
          Service Areas
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-evenly"
          minHeight={200}
          sx={{ padding: 3, backgroundColor: "lightgray" }}
        >
          <Box
            sx={{ width: 200 }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Button size="large" onClick={handleClickOpenServiceArea}>
              <AddCircleOutlineIcon />
            </Button>
            <Typography
              gutterBottom
              variant="body2"
              color="text.secondary"
              component="div"
              sx={{ pt: 1 }}
            >
              Add Service Area
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid sx={{ marginTop: 4 }}>
        <Typography gutterBottom variant="h6" component="div">
          {" "}
          Project Units{" "}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-evenly"
          minHeight={200}
          sx={{ padding: 3, backgroundColor: "lightgray" }}
        >
          <Box
            sx={{ width: 200 }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Button
              size="large"
              //  sx={{ my: 10 }}
            >
              <AddCircleOutlineIcon onClick={handleClickUnitsConfig} />
            </Button>
            <Typography
              gutterBottom
              variant="body2"
              color="text.secondary"
              component="div"
              sx={{ pt: 1 }}
            >
              Add Units
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid sx={{ marginTop: 4 }}>
        <Typography gutterBottom variant="h6" component="div">
          {" "}
          Project Roles{" "}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-evenly"
          minHeight={200}
          sx={{ padding: 3, backgroundColor: "lightgray" }}
        >
          <Box
            sx={{ width: 200 }}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Button
              size="small"
              //  sx={{ my: 10 }}
            >
              <AddCircleOutlineIcon onClick={handleClickRolesConfig} />
            </Button>
            <Typography
              gutterBottom
              variant="body2"
              color="text.secondary"
              component="div"
              sx={{ pt: 1 }}
            >
              Add Project Roles
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          minHeight={100}
          Width="100"
          margin={1}
          padding={3}
        >
          <Button
            variant="contained"
            color="secondary"
            className="close-btn"
            onClick={handleClick}
          >
            Close
          </Button>
          {/* <Button
      variant='contained'
      color='primary'
      className='submit-btn'
      onClick={formSubmissionHandler}
      // disabled={!formIsValid}
    >
      ADD PROJECT
    </Button> */}
        </Box>
      </Grid>
    </Container>
  );
}

export default ProjectInformation;
